"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapAzureOperation = void 0;
/**
 * @author Siglud <siglud@gmail.com>
 */
const storage_blob_1 = require("@azure/storage-blob");
const commonConstant_1 = require("../constant/commonConstant");
function isAzureRestError(error) {
    return error instanceof storage_blob_1.RestError || error.hasOwnProperty("statusCode");
}
function isAzureRemoteServerError(error) {
    var _a;
    return (isAzureRestError(error) &&
        ((_a = error === null || error === void 0 ? void 0 : error.statusCode) !== null && _a !== void 0 ? _a : commonConstant_1.HttpStatusCode.ACCEPTED) >= commonConstant_1.HttpStatusCode.INTERNAL_SERVER_ERROR);
}
async function wrapAzureOperation(operation, remoteErrorHandler, otherErrorHandler) {
    try {
        return await operation();
    }
    catch (error) {
        if (isAzureRemoteServerError(error)) {
            throw remoteErrorHandler(error);
        }
        throw otherErrorHandler(error);
    }
}
exports.wrapAzureOperation = wrapAzureOperation;
//# sourceMappingURL=azureSdkErrorHandler.js.map